import UsernameIcon from '@assets/icons/authenticators/username.svg?react';
import { HexContainer } from '../HexContainer/HexContainer';
import './AuthnCardHeader.less';
import ImprivataDefaultLogo from '@assets/default_logo.svg';
import type React from 'react';

interface AuthenticationHeaderProps {
  hexImage?: React.ReactNode;
  logoUrl?: string;
}

export const AuthnCardHeader = ({
  hexImage = <UsernameIcon />,
  logoUrl,
}: AuthenticationHeaderProps) => {
  return (
    <div className="authn-card-header">
      <span className="authn-card-header-logo">
        {logoUrl ? (
          <img src={logoUrl} alt="logo" />
        ) : (
          <img src={ImprivataDefaultLogo} alt="default-logo" />
        )}
      </span>
      <HexContainer className="authn-card-header-hex" icon={hexImage} />
    </div>
  );
};
